PJQ.views.drawings.DrawingAreaHighlight = PJQ.views.drawings.DrawingViewer.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.DRAWINGS, 'Drawing-Area-Highlight'),
		canEdit: true,
		shouldCreateCanvas: true,
		zoomValue: 100,
		snapView: true,
		isEdit: false,
		context: null,
		maxZoom: 500,
		refreshOnResize: true,
		zoomOnMouseWheel: true,
		isHighlighting: false,
		keyListeners: []
	},
	events: {
		'click .btn-select-name': 'selectName',
		'click .btn-select-title': 'selectTitle',
		'mousedown .iv-image-view': 'canvasMouseDown',
		'mouseup .iv-image-view': 'canvasMouseUp',
		'mousemove .iv-image-view': 'canvasMouseMove',
		'click .btn-save': 'save'
	},
	canvasX: 0,
	canvasY: 0,
	mouse: {
		startX: 0,
		startY: 0
	},
	getMouse: function (e) {
		return {
			x: parseInt((e.clientX - this.canvasX) * this.scale),
			y: parseInt((e.clientY - this.canvasY) * this.scale),
			startX: this.mouse.startX,
			startY: this.mouse.startY
		};
	},
	renderDrawingDetails: function () {
		// override from base view - we never want this to do anything in the area picker
	},
	startMouse: function (e) {
		this.canvasX = this.$canvas.offset().left;
		this.canvasY = this.$canvas.offset().top;
		this.mouse.startX = parseInt((e.clientX - this.canvasX) * this.scale);
		this.mouse.startY = parseInt((e.clientY - this.canvasY) * this.scale);
	},
	canvasMouseDown: function (e) {
		if (!this.options.isHighlighting) {
			return false;
		}
		this.startMouse(e);
		this.mousedown = true;

		let curMouse = this.getMouse(e);
		this.contextLayer.set({
			x: curMouse.startX,
			y: curMouse.startY
		});
	},
	canvasMouseUp: function () {
		this.mousedown = false;
		if (this.contextLayer != null) {
			if (this.contextLayer.get('width') < 0) {
				let wd = this.contextLayer.get('width');
				this.contextLayer.set({
					width: -wd,
					x: this.contextLayer.get('x') + wd
				});
			}

			if (this.contextLayer.get('height') < 0) {
				let ht = this.contextLayer.get('height');
				this.contextLayer.set({
					height: -ht,
					y: this.contextLayer.get('y') + ht
				});
			}

			if (this.contextLayer.get('width') + this.contextLayer.get('x') > this.model.get('pixelsX')) {
				this.contextLayer.set('width', this.model.get('pixelsX') - this.contextLayer.get('x'));
			}

			if (this.contextLayer.get('height') + this.contextLayer.get('y') > this.model.get('pixelsY')) {
				this.contextLayer.set('height', this.model.get('pixelsY') - this.contextLayer.get('y'));
			}

			this.contextLayer = null;
			this.options.isHighlighting = false;
			this.$activeCanvas.removeClass('annotate');
			this.renderSelectionActions();
		}
	},
	canvasMouseMove: function (e) {
		if (!this.options.isHighlighting || !this.mousedown) {
			return;
		}

		let curMouse = this.getMouse(e);
		this.contextLayer.set({
			width: curMouse.x - curMouse.startX,
			height: curMouse.y - curMouse.startY,
		});
		this.renderAnnotations();
	},
	renderAnnotations: function () {
		if (this.loaded) {
			this.clearCanvas(this.activeCtx);
			if (this.nameLayer != null) {
				this.drawRectangle(this.nameLayer);
			}
			if (this.titleLayer != null) {
				this.drawRectangle(this.titleLayer);
			}
		}
	},
	drawRectangle: function (rect) {
		this.activeCtx.beginPath();
		this.activeCtx.rect(rect.get('x') / this.scale, rect.get('y') / this.scale, rect.get('width') / this.scale, rect.get('height') / this.scale);
		this.activeCtx.fillStyle = rect.get('color');
		this.activeCtx.fill();
	},
	selectName: function () {
		if (this.options.isHighlighting) {
			this.contextLayer = null;
			this.options.isHighlighting = false
			this.$activeCanvas.removeClass('annotate');
		}
		else {
			this.options.isHighlighting = true;
			this.$activeCanvas.addClass('annotate');
			this.nameLayer = null;
			this.renderAnnotations();
			this.nameLayer = new PJQ.models.BaseModel({
				layerId: 'name',
				type: 'rect',
				color: '#4caf5075'
			});
			this.contextLayer = this.nameLayer;
		}
		this.renderSelectionActions();
	},
	selectTitle: function () {
		if (this.options.isHighlighting) {
			this.contextLayer = null;
			this.options.isHighlighting = false;
			this.$activeCanvas.removeClass('annotate');
		}
		else {
			this.options.isHighlighting = true;
			this.$activeCanvas.addClass('annotate');
			this.titleLayer = null;
			this.renderAnnotations();
			this.titleLayer = new PJQ.models.BaseModel({
				layerId: 'title',
				type: 'rect',
				color: '#ef6c0075'
			});
			this.contextLayer = this.titleLayer;
		}
		this.renderSelectionActions();
	},
	renderSelectionActions: function () {
		if (this.contextLayer != null) {
			if (this.contextLayer.get('layerId') === 'title') {
				this.$('.btn-select-name').prop('disabled', true);
				this.$('.btn-select-title').text('Stop Selecting Title').prop('disabled', false);
			}
			else if (this.contextLayer.get('layerId') === 'name') {
				this.$('.btn-select-title').prop('disabled', true);
				this.$('.btn-select-name').text('Stop Selecting Name').prop('disabled', false);
			}
		}
		else {
			this.$('.btn-select-name').text(this.nameLayer != null ? 'Change Name Area' : 'Select Name Area').prop('disabled', false);
			this.$('.btn-select-title').text(this.titleLayer != null ? 'Change Title Area' : 'Select Title Area').prop('disabled', false);
		}

	},
	canDrag: function () {
		return !this.options.isHighlighting;
	},
	save: function () {
		if (typeof this.options.onSave === 'function') {
			this.options.onSave({
				layers: {
					name: this.nameLayer,
					title: this.titleLayer
				}
			});
			this.destroy();
		}
	}
});